import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { IconGripVertical, IconTrash } from "@tabler/icons-react";

function SortableSectionItemCard({
  item,
  visibleLanguageIso,
  children,
  onDelete,
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: item.id,
    });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const itemTitle =
    item?.title?.[visibleLanguageIso] || item?.title?.en || "Untitled item";

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="before-you-go-tool-item-card"
    >
      <div className="before-you-go-tool-item-card-head">
        <div className="before-you-go-tool-item-card-title">
          <button
            type="button"
            className="before-you-go-tool-drag before-you-go-tool-drag--item"
            aria-label="Reorder item"
            title="Reorder item"
            {...attributes}
            {...listeners}
          >
            <IconGripVertical size={14} />
          </button>
          <div>
            <strong>{itemTitle}</strong>
          </div>
        </div>
        <button
          type="button"
          className="app-icon-btn app-icon-btn--delete"
          aria-label="Delete item"
          title="Delete item"
          onClick={onDelete}
        >
          <IconTrash size={14} />
        </button>
      </div>
      {children}
    </div>
  );
}

export default SortableSectionItemCard;
